import React from 'react';
import { FiExternalLink } from 'react-icons/fi';
import styles from '@pages/api-portal/styles.module.scss';
import { gatewayUrl } from '@constants/settings';
import { MethodBadge } from '@pages/api-portal/method-badge';
import { API_EXAMPLES_DOCS_URL } from '@pages/api-portal/constants';
import { ApiEndpoint } from '@pages/api-portal/types';

/*
 * Builds a cURL command string from catalog metadata — for documentation display only,
 * separate from the Try It Out console's actual request execution.
 */
export function generateCurlExample(endpoint: ApiEndpoint): string {
    let curl = `curl -X ${endpoint.method} "${gatewayUrl}${endpoint.path}"`;

    endpoint.parameters?.header?.forEach((header) => {
        curl += ` \\\n  -H "${header.name}: ${header.example || '{value}'}"`;
    });

    if (endpoint.parameters?.body) {
        curl += ` \\\n  -H "Content-Type: ${endpoint.parameters.body.contentType}"`;
        curl += ` \\\n  -d '${JSON.stringify(endpoint.parameters.body.example, null, 2)}'`;
    }

    return curl;
}

interface CurlExampleCardProps {
    endpoint: ApiEndpoint;
}

/*
 * Examples tab content: a generated cURL command for the endpoint.
 */
export function CurlExampleCard({ endpoint }: CurlExampleCardProps) {
    return (
        <div className={styles.card}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <MethodBadge method={endpoint.method} />
                    <code className={styles.mutedText} style={{ fontSize: 12 }}>
                        {gatewayUrl}
                        {endpoint.path}
                    </code>
                </div>
                <a
                    href={API_EXAMPLES_DOCS_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.mutedText}
                    style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 12, flexShrink: 0 }}
                >
                    <FiExternalLink /> Docs
                </a>
            </div>
            <div className={styles.cardDivider} />
            <pre className={styles.codeBlock}>{generateCurlExample(endpoint)}</pre>
        </div>
    );
}
